import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, Observer, Subscriber } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Environment } from '../env';


export class OHttpLoaderService implements TranslateLoader {

  constructor(private http: HttpClient, private prefix: string, private suffix: string) { }

  getTranslation(lang: string): Observable<any> {
    return new Observable((observer: Observer<any>) => {
      if (!environment.production) {
        return this.getLocalTranslation(lang, observer);
      }
      this.http.get(`${Environment.SERVER}/common/internalConfigs?key=APP_${lang.toUpperCase()}`, {
        headers: {
        }
      }).pipe(timeout(5_000)).subscribe((res: any) => {
        if (res.length === 0) {
          return this.getLocalTranslation(lang, observer);
        }
        try {
          const json = JSON.parse(res[0].value);
          console.log('JSON:::', json);
          observer.next(json);
          observer.complete();
        } catch (error) {
          this.getLocalTranslation(lang, observer);
        }
      },
        (error) => {
          console.log('Error:', error);
          this.getLocalTranslation(lang, observer);
        }
      );
    });
  }
  private getLocalTranslation(lang: string, observer: Observer<any>) {
    this.http.get(`${this.prefix}${lang}${this.suffix}`).subscribe((res: any) => {
      console.log('JSON:::', res);
      observer.next(res);
      observer.complete();
    });
    // , err => {
    //   this.http.get(`${this.prefix}fr${this.suffix}`).subscribe((res: any) => {
    //     observer.next(res.json());
    //     observer.complete();
    //   });
    // });
  }
}
